module.exports = __webpack_public_path__ + "static/media/Order_Execution_Policy_v1.1.11f1e238.pdf";